module.exports = __webpack_public_path__ + "static/media/0.1b19f242.mp3";